{
	"failed": {
		"description": "Controlla la connessione e riprova.",
		"retry": "Riprova",
		"title": "Non è stato possibile aprire il link"
	},
	"file": {
		"download": "Scarica",
		"download_failed": "Download non riuscito",
		"download_pending": "Preparazione del download…",
		"expires": "Scade il {{date}}",
		"link_expires": "Il link scade il {{date}}",
		"refused": {
			"failed": "Non è stato possibile raggiungere il file. Riprova.",
			"relocked": "Il link si è richiuso. Inserisci di nuovo la password.",
			"throttled_one": "Troppe richieste. Riprova tra {{count}} minuto.",
			"throttled_other": "Troppe richieste. Riprova tra {{count}} minuti.",
			"unavailable": "Questo file non è più raggiungibile tramite il link."
		},
		"shared_by": "Condiviso da {{name}}",
		"shared_with_you": "<sender>{{name}}</sender> ha condiviso un file con te"
	},
	"folder": {
		"contents": "Contenuto di {{name}}",
		"download_file": "Scarica {{name}}",
		"empty": "Questa cartella è vuota",
		"failed": {
			"description": "Può essere stata spostata, oppure la connessione si è interrotta. Ricarica la pagina.",
			"title": "Non è stato possibile aprire questa cartella"
		},
		"items_one": "{{count}} elemento",
		"items_other": "{{count}} elementi",
		"load_more": "Mostra altri",
		"loading": "Caricamento della cartella…",
		"loading_more": "Caricamento…",
		"shared_by": "Condivisa da {{name}}"
	},
	"header": {
		"language": "Lingua"
	},
	"loading": "Caricamento del link…",
	"password": {
		"description": "Inserisci la password che ti ha dato chi ha condiviso il file.",
		"label": "Password",
		"pending": "Verifica…",
		"submit": "Apri",
		"throttled_one": "Troppi tentativi. Riprova tra {{count}} minuto.",
		"throttled_other": "Troppi tentativi. Riprova tra {{count}} minuti.",
		"title": "Questo link è protetto da password",
		"wrong": "La password non è corretta."
	},
	"relock": {
		"description": "Il link si richiude dopo 10 minuti senza attività. Inserisci di nuovo la password per continuare da qui."
	},
	"throttled": {
		"description_one": "Sono arrivate troppe richieste da questa rete. Riprova tra {{count}} minuto.",
		"description_other": "Sono arrivate troppe richieste da questa rete. Riprova tra {{count}} minuti.",
		"title": "Troppi tentativi"
	},
	"unavailable": {
		"description": "Può essere scaduto o revocato, oppure l'indirizzo non è completo. Chiedi a chi te l'ha inviato di condividerlo di nuovo.",
		"title": "Questo link non è disponibile"
	},
	"upload": {
		"add": "Aggiungi file",
		"cancel": "Annulla l'invio di {{name}}",
		"change_name": "Cambia",
		"empty": {
			"description": "Carica i documenti richiesti in modo sicuro. I file arriveranno direttamente a {{name}}.",
			"description_anonymous": "Carica i documenti richiesti in modo sicuro. I file arriveranno direttamente nella cartella.",
			"title": "Trascina qui i file da inviare"
		},
		"requested_by": "Richiesta da {{name}}",
		"retry": "Invia di nuovo {{name}}",
		"sender": {
			"hint": "Lo vedrà accanto ai file che invii.",
			"label": "Come ti chiami?",
			"placeholder": "Nome e cognome, o azienda",
			"submit": "Inizia",
			"title": "{{name}} ti chiede dei file",
			"title_anonymous": "Ti sono stati chiesti dei file"
		},
		"sending_as": "Invii come {{name}}",
		"size": "{{sent}} di {{total}}",
		"status": {
			"cancelled": "Annullato",
			"delivered": "Consegnato",
			"failed": "Non riuscito",
			"no_room": "La cartella non ha spazio per questo file",
			"relocked": "Il link si è richiuso. Inserisci di nuovo la password.",
			"sending": "Invio in corso",
			"throttled": "Troppi invii per ora, riprova più tardi",
			"too_large": "Troppo grande per questo link",
			"unavailable": "Il link non accetta più file",
			"waiting": "In attesa"
		},
		"table": {
			"actions": "Azioni",
			"label": "File inviati da questa pagina",
			"name": "Nome",
			"size": "Dimensione",
			"status": "Stato",
			"type": "Tipo"
		}
	}
}
